import React, { useState } from "react";
import "./LoginPage.css";

import domikLogo from "../../../content/images/logo128.png"; // Tell webpack this JS file uses this image
import { serviceAuthentication } from "../../../services/AuthenticationService";

export const LoginPage = () => {
  const [authenticationData, setAuthenticationData] = useState({
    username: "",
    password: "",
  });
  const [authenticationStatus, setAuthenticationStatus] = useState({
    message: "",
  });

  let doLogin = () => {
    if (
      authenticationData.username === "" ||
      authenticationData.password === ""
    ) {
      setAuthenticationStatus({
        message: "Vyplňte prosím uživatelské jméno i heslo",
      });
      return;
    }

    serviceAuthentication.login(authenticationData).then(
      (user: any) => {
        if (user.data.incorrectCredentials) {
          setAuthenticationStatus({
            message: "Neplatné uživatelské jméno nebo heslo",
          });
        } else {
          localStorage.setItem("currentUser", JSON.stringify(user.data));
          serviceAuthentication.currentUserSubject.next(user.data);
          setAuthenticationStatus({ message: "" });

          // XSRF token je potřeba jen pro produkční antiforgery, jeho selhání nesmí zablokovat přihlášení
          const continueToApplication = () => {
            window.location.href = "/";
          };

          serviceAuthentication
            .loginResult()
            .then(continueToApplication, continueToApplication);
        }
      },
      (error) => {
        setAuthenticationStatus({
          message: "Nepodařilo se ověřit uživatelské jméno nebo heslo",
        });
      }
    );
  };

  return (
    <div
      style={{ color: "black", maxWidth: "350px", textAlign: "center" }}
      className="container z-depth-1 my-5 px-0"
    >
      <img src={domikLogo} alt="Domik logo" style={{ margin: "20px" }} />
      <div className="card">
        <div className="card-header">
          <i className="fas fa-unlock" style={{ marginRight: "10px" }}></i>
          Přihlášení uživatele
        </div>
        <div
          className="card-body"
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              doLogin();
            }
          }}
        >
          <input
            onChange={(event) => {
              authenticationData.username = event.target.value;
              setAuthenticationData(authenticationData);
            }}
            type="input"
            id="username"
            className="form-control mb-4"
            placeholder="Uživatelské jméno"
          />
          <input
            onChange={(event) => {
              authenticationData.password = event.target.value;
              setAuthenticationData(authenticationData);
            }}
            type="password"
            id="password"
            className="form-control mb-4"
            placeholder="Heslo"
          />

          {authenticationStatus.message !== "" && (
            <span style={{ color: "red" }}>{authenticationStatus.message}</span>
          )}

          <input
            onClick={() => {
              doLogin();
            }}
            className="btn btn-info btn-block my-4"
            type="button"
            value="Přihlásit"
          />
        </div>
      </div>
    </div>
  );
};
